<template>
  <div>
    <v-carousel
      cycle
      class="a"
      interval="5000"
      hide-delimiter-background
      show-arrows-on-hover
      v-model="model"
    >
      <v-carousel-item
        class="a"
        style="height: 600px"
        v-for="(slide, i) in slides"
        :key="i"
        :src="imgs[i]"
        :to="link[i]"
        @click="open(i)"
      >
        <v-row class="fill-height" :to="link[i]">
          <div style="font-weight: 500px" class="disp">
            {{ slide }}
          </div>
        </v-row>
      </v-carousel-item>
    </v-carousel>
    <v-carousel
      cycle
      height="50"
      interval="5000"
      hide-delimiters
      :show-arrows="false"
      v-model="model"
    >
      <v-carousel-item v-for="(text, i) in texts" :key="i">
        <v-row class="mt-3 texts1" align="center" justify="center">
          <div v-if="$vuetify.theme.dark == true">{{ text }}</div>
          <div v-else style="color: black">{{ text }}</div>
        </v-row>
        <v-row class="mt-3 texts2" align="center" justify="center">
          <div style="font-size: 12px" v-if="$vuetify.theme.dark == true">
            {{ text }}
          </div>
          <div v-else style="color: black; font-size: 12px">{{ text }}</div>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgs: [
        {
          src: require("../../../../styles/drawable-home/cancontrol-capa.webp"),
        },
        {
          src: require("../../../../styles/drawable-home/cancroEuropeu-capa.webp"),
        },
        {
          src: require("../../../../styles/drawable-home/manejo-capa.webp"),
        },
        {
          src: require("../../../../styles/drawable-home/imagens-capa.webp"),
        },
        {
          src: require("../../../../styles/drawable-home/videos-capa.webp"),
        },
      ],
      slides: [
        "Cancontrol",
        "Cancro Europeu",
        "Medidas e Manejos",
        "Imagens",
        "Vídeos",
      ],
      link: ["/", "/cancro", "/medidas", "/fotos", "/videos"],
      texts: [
        "Baixe o APP na Google Play Store",
        "Veja as últimas informações sobre o Cancro Europeu",
        "Veja as últimas informações sobre as Medidas e Manejos",
        "Visualize imagens sobre o Cancro",
        "Assista nossos vídeos sobre o cancro",
      ],
      model: 0,
    };
  },
  methods: {
    open(i) {
      if (i == 0) {
        window.open(
          "https://play.google.com/store/apps/details?id=br.edu.ifsc.cancontrol&hl=pt-BR",
          "_blank"
        );
      }
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 1367px) {
  .a {
    max-height: 400px;
  }
  .disp {
    font-weight: 500;
    height: 40px;
    font-size: 40px;
  }
  .fill-height {
    padding-left: 40px;
    padding-bottom: 130px;
    align-items: flex-end;
    justify-items: center;
  }
}
@media only screen and (min-width: 1368px) {
  .disp {
    font-weight: 500;
    height: 60px;
    font-size: 60px;
  }
  .fill-height {
    padding: 50px;
    align-items: flex-end;
    justify-items: end;
  }
}
@media only screen and (max-width: 443px) {
  .texts1 {
    display: none;
  }
  .disp {
    font-weight: 500;
    height: 40px;
    font-size: 30px;
  }
}
@media only screen and (min-width: 444px) {
  .texts2 {
    display: none;
  }
}
</style>
